import { createFileRoute } from '@tanstack/react-router'
import { JornadaPage } from '~/components/marketing/jornada-page'
import { MarketingShell } from '~/components/marketing/marketing-shell'
import { marketingPageHead } from '~/lib/site-meta'

const PAGE_TITLE = 'A jornada de um projeto: do WhatsApp à entrega das chaves | Planno'
const PAGE_DESCRIPTION =
  'Acompanhe um projeto de interiores de ponta a ponta no Planno: o áudio que vira lead, o briefing por link, a proposta aceita, o portal da cliente e a entrega. Cinco meses contados dia a dia.'

export const Route = createFileRoute('/jornada')({
  component: JornadaRoute,
  head: () =>
    marketingPageHead({
      description: PAGE_DESCRIPTION,
      locale: 'pt-BR',
      path: '/jornada',
      title: PAGE_TITLE,
    }),
})

function JornadaRoute() {
  return (
    <MarketingShell>
      <JornadaPage />
    </MarketingShell>
  )
}
